import { Component, OnInit, EventEmitter, Input, Output  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { UserService } from '@sparro/api/user/user.service';
import { Project } from '@sparro/app/core/models/project.model';
import { environment } from '@sparro/env/environment';
import { ConfirmationDialogComponent } from '@sparro/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ProjectService } from '@sparro/app/core/api/project/project.service';
import { SnackbarService } from '@sparro/app/core/helpers/toastr/snackbar.service';
import { FollowerService } from '@sparro/app/core/api/follower/follower.service';
import { User } from '@sparro/app/core/models/user.model';
import { Report } from '@sparro/app/core/models/report.model';
import { ShareDialogComponent } from '@sparro/app/shared/components/dialogs/share-dialog/share-dialog.component';
import { ReportDialogComponent } from '@sparro/app/shared/components/dialogs/report-dialog/report-dialog.component';

@Component({
  selector: 'uni-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {
  @Input() projectCheck: Project;
  @Input() showContextMenuCheck: boolean = false;
  @Input() selfCheck: boolean = false;
  @Output() removedProject = new EventEmitter();

  source = 'neo_projects';
  user: User;
  constructor(
    private dialog: MatDialog,
    private userService: UserService,
    private projectService: ProjectService,
    private followerService: FollowerService,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void { 
    this.getAuthUser();
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.userService.user.subscribe(
            (user: User) => {
              this.user = user;
            });
        }
      });
  }

  goToProject(): void {
    const url = `${environment.projectUploaderUrl}project/${this.projectCheck.uuid}/edit`;
    window.open(url, '_blank');
  }

  deleteProject(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '380px',
      height: '150px',
      data: {
        message: 'Are you sure you want to delete this project?',
        okayButtonText: 'Yes'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.projectService.deleteProject(this.projectCheck.uuid).subscribe(
          (response: any) => {
            this.removedProject.emit(this.projectCheck.uuid);
            // show toastr
          }, (err) => {
            console.log(err);
          });
      } else {
      }
    });
  }

  togglePrivate(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to make this project ${this.projectCheck.private ? 'public' : 'private'}?`,
        okayButtonText: 'Yes'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.projectService.togglePrivate(this.projectCheck.uuid).subscribe(
          (response: any) => {
            if (response) {
              this.projectCheck.private = !this.projectCheck.private;
            }
          }, (err) => {
            console.log(err);
          });
      } else {
      }
    });
  }

  toggleFollow() {
    if (this.projectCheck.is_following) {
      this.followerService.unfollow(this.source, this.projectCheck.slug, this.projectCheck.is_following?.id).subscribe(
        (response) => {
          if (response) {
            this.projectCheck.is_following = null;
            this.snackbarService.success('Unfollow')

          }
        });
    } else {
      const data = {
        follower: this.user.id
      };
      this.followerService.follow(this.source, this.projectCheck.slug, data).subscribe(
        (response: any) => {
          this.projectCheck.is_following = response;
          this.snackbarService.success('Following')
        },
        (err) => {
          console.log(err);
        });
    }
  }

  openShareDialog() {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
      data: {
        sourceCopy: 'projects',
        slug: this.projectCheck.slug,
        content: {
          title: this.projectCheck.content.title,
          subtitle: this.projectCheck.content.desc,
          cover_image: this.projectCheck?.content.cover.media.url
        }
      }
    });

    dialogRef.afterClosed().subscribe(
      (response) => {

      });
  }

  redirectToLogin() {
    window.location.href = `${environment.loginUrl}authentication?service=sign-in&continue=${window.location.href}`;
  }

  createReport() {
    if (!this.user) {
      this.redirectToLogin();
      return;
    } else {
      const dialogWidth = window.innerWidth <= 500 ? `90vw` : `527px`;
      const dialogRef = this.dialog.open(ReportDialogComponent, {
        width: dialogWidth,
        maxWidth: dialogWidth,
        data: {
          user: this.user,
          slug: this.projectCheck.slug,
          source: this.source,
          url: `${environment.projectUrl}${this.projectCheck.slug}`
        }
      });
      dialogRef.afterClosed().subscribe(
        (response: any) => {
          if (response) {
            this.projectCheck.report = response;
            this.snackbarService.success('Report has been initiated');
          }
        });
    }
  }

  redactReport() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '420px',
      data: {
        message: `This will withdraw the report and the action cannot be undone.
        Are you sure you want to continue?`,
        okayButtonText: 'Yes'
      }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          Report.redactReport(this.source, this.projectCheck.slug, this.projectCheck.report.id).subscribe(
            (response: any) => {
              if (response) {
                this.projectCheck.report = response;
                this.snackbarService.success('Report has been redacted');
              }
            });
        }
      });
  }
}
